import { useEffect } from 'react';
import { useGetDatabaseStructureService } from '../services/useGetDatabaseStructureService';

const DatabaseStructureFetcher = () => {
    const { getDatabaseStructure } = useGetDatabaseStructureService();

    // Zavisi samo od same funkcije: ona je `useCallback` nad naloga, servera i
    // adrese, pa se njen identitet menja tačno kad se izbor promeni — a to je
    // ono što je ranije stajalo u `[selected]`. Jedan izvor istine umesto dva
    // koja mogu da se raziđu.
    useEffect(() => {
        getDatabaseStructure();
    }, [getDatabaseStructure]);
    
    return null;
};

export default DatabaseStructureFetcher;
